import { useMemo } from 'react'
import { BasicMesh } from '@modugen/ui-toolkit'
import { useAppStore } from '@stores'
import { getContrastTextColor } from 'src/utils/color'
import Arrow from '../Arrow'
import { getLoadCategoryColor, highlightLoadColor } from '../loads'
import useElementDirectionForTextDirection from './useElementDirectionForTextDirection'

const POINT_LOAD_ARROW_LINE_WIDTH = 0.015
const POINT_LOAD_TEXT_OFFSET_HALF_WIDTH = POINT_LOAD_ARROW_LINE_WIDTH / 2 + 0.001

interface Props {
  load: PointLoad
  loadDisplayData: PointLoadDisplayData
  onClick?: () => void
  isActive?: boolean
  color?: string
  opacity?: number
}

const PointLoadMeshElement = ({
  load,
  loadDisplayData,
  onClick,
  isActive,
  color,
  opacity = 1,
}: Props) => {
  const { magnitudePoints: loadPoint, label } = loadDisplayData

  const direction = useMemo(
    () => loadPoint[0].from.clone().sub(loadPoint[0].to).normalize().setZ(-1),
    [loadPoint],
  )

  const length = useMemo(() => loadPoint[0].from.clone().sub(loadPoint[0].to).length(), [loadPoint])

  const loadTextScale = useAppStore(state => state.loadRenderConfig.pointLoads.textScale)

  const loadColor = getLoadCategoryColor(load.load_case.category)
  const backgroundColor = isActive ? color || highlightLoadColor : color || loadColor
  const textColor = getContrastTextColor(backgroundColor)

  const textXDirection = useElementDirectionForTextDirection(load.element_guid)

  return (
    <BasicMesh cursor="pointer" onClick={onClick}>
      <Arrow
        onClick={onClick}
        direction={direction}
        origin={loadPoint[0].to}
        length={length}
        label={label}
        highlighted={isActive}
        color={textColor}
        backgroundColor={backgroundColor}
        labelScale={loadTextScale}
        textXDirection={textXDirection.v}
        textOffsetHalfWidth={POINT_LOAD_TEXT_OFFSET_HALF_WIDTH}
        lineWidth={POINT_LOAD_ARROW_LINE_WIDTH}
        opacity={opacity}
        labelAnchorLocation="bottom"
      />
    </BasicMesh>
  )
}

export default PointLoadMeshElement
